module.exports = __webpack_public_path__ + "img/business-offer.1970142f.jpg";